import { Component, OnInit,Input } from '@angular/core';

import { Product } from '../../entities/product.entities';
import { ProductService } from '../../services/product.service';
import { CartService } from '../../services/cart.service';
import { Title } from '@angular/platform-browser';


@Component({
  selector: 'app-recomment-product',
  templateUrl: './recomment-product.component.html',
  styleUrls: ['./recomment-product.component.css']
})
export class RecommentProductComponent implements OnInit {

  @Input('data') meals: string[] = [];
  page: number = 1;

  private products: Product[];
  rows: any[] = [];

  constructor(private productService: ProductService,private titleService: Title) {
  }
  ngOnInit() {
    this.titleService.setTitle("สินค้าแนะนำ");
    this.productService.getProductRever().subscribe((snapshot) => {
      this.products = snapshot;
    });
  }
}



// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/components/recomment-product/recomment-product.component.ts